export default {
	title: "Assistant ORI",
	subtitle: "Posez vos questions sur le système",
	openLabel: "Ouvrir l'assistant",
	closeLabel: "Fermer",
	expandLabel: "Agrandir",
	collapseLabel: "Réduire",
	clearLabel: "Effacer la conversation",
	placeholder: "Écrivez votre question...",
	send: "Envoyer",
	thinking: "En train d'écrire...",
	emptyTitle: "Comment puis-je vous aider ?",
	emptyHint: "Posez des questions sur les inscriptions, les rituels, les finances et plus encore.",
	disclaimer:
		"Les réponses générées par l'IA peuvent contenir des erreurs. Vérifiez les informations importantes.",
	clearConfirm: "Supprimer toute la conversation ?",
	errorGeneric: "Je n'ai pas pu répondre pour le moment. Veuillez réessayer.",
	errorUnavailable: "Assistant indisponible pour le moment.",
	suggestions: {
		s1: "Comment enregistrer une personne ?",
		s2: "Comment faire l'appel des fiches ?",
		s3: "Où voir la clôture financière ?",
	},
	guidedMode: {
		question: "Comment préférez-vous configurer le terreiro ?\n\n**Automatique** : je prépare chaque fiche et vous la confirmez simplement sur la carte.\n**Manuel** : je vous guide à l'écran et vous la créez, en apprenant le chemin.",
		automatic: "Automatique",
		manual: "Manuel",
	},
	quickReplies: {
		label: "Options de réponse",
	},
	actions: {
		confirm: "Confirmer",
		edit: "Modifier",
		cancel: "Annuler",
		created: "Créé avec succès !",
		createError: "Je n'ai pas pu créer. Veuillez réessayer.",
		createErrorWithReason: "Impossible de le créer : {reason}",
		checkOnScreen: "Cet enregistrement a peut-être déjà été créé. Vérifiez l'écran avant de le redemander.",
		noPermission: "Vous n'avez pas la permission pour cela.",
		continue: "Continuer",
		continueMsg: "C'est fait, créé. Passons au suivant.",
	},
};
